/* eslint-disable */
export default {
  unknown: 'Unknown',
  anonymous: 'Anonymous',
  activeCalls: 'All Calls',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
